import { Controller, Menu, Toolbar } from '@tencent/workbench';
import { FileCompressionFeature } from './file-compression-feature';
import { config, TOOLBAR_CONFIGS } from './config';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { isClientDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';

@Controller({
    toolbarItems: TOOLBAR_CONFIGS,
})
export class FileCompressionController {
    public constructor(private readonly fileCompressionFeature: FileCompressionFeature) {}

    @Toolbar(config.id, 'onClick')
    @Toolbar(wrapIdForBig(config.id), 'onClick')
    @Menu(config.id, 'onClick')
    public fileCompression() {
        this.fileCompressionFeature.compression();
    }

    @Toolbar(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    @Menu(config.id, 'shouldHide')
    public handleHide() {
        return !isClientDriveFile();
    }
}
